var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16C21.5523 16 22 16.4477 22 17V19C22 19.5523 21.5523 20 21 20H10C9.44772 20 9 19.5523 9 19V17C9 16.4477 9.44772 16 10 16H21ZM21 10C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14H10C9.44772 14 9 13.5523 9 13V11C9 10.4477 9.44772 10 10 10H21ZM21 4C21.5523 4 22 4.44772 22 5V7C22 7.55228 21.5523 8 21 8H10C9.44772 8 9 7.55228 9 7V5C9 4.44772 9.44772 4 10 4H21Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 4H3C2.44772 4 2 4.44772 2 5V7C2 7.55228 2.44772 8 3 8H6C6.55228 8 7 7.55228 7 7V5C7 4.44772 6.55228 4 6 4Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 10H3C2.44772 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H6C6.55228 14 7 13.5523 7 13V11C7 10.4477 6.55228 10 6 10Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 16H3C2.44772 16 2 16.4477 2 17V19C2 19.5523 2.44772 20 3 20H6C6.55228 20 7 19.5523 7 19V17C7 16.4477 6.55228 16 6 16Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryCard);
export default __webpack_public_path__ + "static/media/gallery-card.f8aba50c0fa2e706a85ee788d8bd1c8e.svg";
export { ForwardRef as ReactComponent };